import { render, staticRenderFns } from "./villagedetail.vue?vue&type=template&id=468383bc&scoped=true&"
import script from "./villagedetail.vue?vue&type=script&lang=js&"
export * from "./villagedetail.vue?vue&type=script&lang=js&"
import style0 from "./villagedetail.vue?vue&type=style&index=0&id=468383bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468383bc",
  null
  
)

component.options.__file = "villagedetail.vue"
export default component.exports